import * as React from 'react';

import UILoading from '../../../components/Loading';

import './PopupLoading.scss';

export class PopupLoading extends React.Component {
  render() {
    return (
      <div className={'PopupLoading'}>
        <UILoading />
      </div>
    );
  }
}
